module.exports = __webpack_public_path__ + "7272ab2322ccab0b1947f3fde2b51df2.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/Klabauterbett_Fahnenlogo_schwarz.svg
// module id = 956
// module chunks = 0